import { Model } from '@contember/schema';
import { noCase } from 'change-case';
import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { SchemaDslBuilderError } from '../../SchemaDslBuilder';
export const onDeleteStmtInstruction = `
#### Relationship "On Delete" behaviour
For many to one and one to one it is possible to set on delete behaviour. E.g. what should happen when "category" of "article" is deleted
- Syntax: \`on delete <owning_entity>.<owning_field> cascade;\`
- Syntax: \`on delete <owning_entity>.<owning_field> restrict;\`
- Syntax: \`on delete <owning_entity>.<owning_field> set null;\`
- Example: \`on delete Article.category set null;\`
- Example: \`on delete OrderItem.product restrict;\``;
export const stmtOnDelete = ({ owningEntity, owningField, action }) => {
    return `on delete ${owningEntity}.${owningField} ${action};`;
};
export const stmtForHumanOnDelete = ({ owningEntity, owningField, action }) => {
    return `Set the "on delete" behaviour for the relationship between __${noCase(owningEntity)}__ and __${noCase(owningField)}__ to __${noCase(action)}__.`;
};
export const onDeleteHandler = createSchemaStatementHandler({
    type: 'on delete',
    parse: line => {
        const match = /^on delete (?<owningEntityName>\w+)\.(?<owningFieldName>\w+) (?<action>cascade|restrict|set null)/.exec(line);
        const onDeleteAction = match?.groups?.action;
        if (match?.groups && !isOnDeleteAction(onDeleteAction)) {
            throw new SchemaDslBuilderError(`Unknown onDelete action ${onDeleteAction}`);
        }
        return match?.groups
            ? {
                type: 'on delete',
                owningEntity: formatEntityName(match.groups.owningEntityName),
                owningField: formatFieldName(match.groups.owningFieldName),
                action: onDeleteAction,
            }
            : null;
    },
    getHumanStmt: (stmt) => stmtForHumanOnDelete(stmt),
    apply: (stmt, builder) => {
        const convertOnDelete = (onDelete) => {
            switch (onDelete) {
                case 'cascade':
                    return Model.OnDelete.cascade;
                case 'restrict':
                    return Model.OnDelete.restrict;
                case 'set null':
                    return Model.OnDelete.setNull;
            }
            throw new SchemaDslBuilderError(`Unknown onDelete action ${onDelete}`);
        };
        builder.updateSchema(it => it.updateRelationOnDelete(stmt.owningEntity, stmt.owningField, convertOnDelete(stmt.action)));
    },
});
const isOnDeleteAction = (value) => (value ? ['cascade', 'restrict', 'set null'].includes(value) : false);
export const onDeleteMapping = {
    'set null': Model.OnDelete.setNull,
    cascade: Model.OnDelete.cascade,
    restrict: Model.OnDelete.restrict,
};
//# sourceMappingURL=OnDeleteStmt.js.map